import OneSignal from "react-onesignal";

export const loginToOneSignal = async (id) => {
  try {
    const newExternalId = `user_${id}`;
    const currentExternalId = OneSignal?.User?.externalId;

    // Same user already logged in
    if (currentExternalId === newExternalId) {
      return { success: true, externalId: newExternalId };
    }

    // Switch user safely
    if (currentExternalId && currentExternalId !== newExternalId) {
      // console.log(
      //   `Switching OneSignal user ${currentExternalId} → ${newExternalId}`
      // );
      await OneSignal.logout(); // DO NOT optOut
      await new Promise((r) => setTimeout(r, 300));
    }

    // Login new user
    await OneSignal.login(newExternalId);
    await new Promise((r) => setTimeout(r, 300));

    const verifiedExternalId = OneSignal?.User?.externalId;
    if (verifiedExternalId === newExternalId) {
      return { success: true, externalId: verifiedExternalId };
    }

    return { success: false, reason: "externalId_verification_failed" };
  } catch (error) {
    console.error("OneSignal login error:", error);
    return { success: false };
  }
};

export const logoutOnesignal = async () => {
  try {
    const externalId = OneSignal?.User?.externalId;

    if (!externalId) {
      return { success: true };
    }

    // Logout only — DO NOT optOut
    await OneSignal.logout();
    await new Promise((r) => setTimeout(r, 300));

    return { success: true };
  } catch (error) {
    console.error("OneSignal logout error:", error);
    return { success: false };
  }
};

export const ensureNotificationSubscription = async (setState) => {
  const permission = Notification.permission;

  // console.log("Notification.permission: ", permission);
  const optedIn = OneSignal?.User?.PushSubscription?.optedIn;

  if (optedIn) {
    return "subscribed";
  }

  if (permission === "denied") {
    setState((prev) => ({ ...prev, showNotificationModal: true }));
    return "blocked"; // show instructions
  }

  await OneSignal.Slidedown.promptPush();
  return "prompted";
};
